import { render, staticRenderFns } from "./DeviceGroups.vue?vue&type=template&id=6f27b1f8"
import script from "./DeviceGroups.vue?vue&type=script&lang=js"
export * from "./DeviceGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports